import React, { Component } from 'react'
import { i18nTranslate } from 'src/utils'
import { Button, Modal } from 'react-bootstrap'
import './styles.scss'

class AccountConvertedSuccessPopup extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      isToShowPopUp = true,
      message,
      handleShowAccountConvertedSuccessModalClose,
    } = this.props

    return (
      <Modal
        show={isToShowPopUp}
        className="conversion-disclaimer-modal rounded-md modal-dialog-centered">
        <Modal.Body className="conversion-disclaimer-modal">
          <h4 className="conversion-disclaimer-modal-title">
            {i18nTranslate(
              'ba_to_member_account_changed_to_member_account',
              'Your account has been successfully changed to a Member account.'
            )}
          </h4>
          <p className="conversion-disclaimer-modal-content">
            {i18nTranslate(
              'ba_to_member_email_confirmation',
              'You will receive an email confirmation and be signed out. Please sign back in to see your changes.'
            )}
          </p>
          <div className="row">
            <div className="col-12">
              <Button
                className="cancel-button rounded-md w-100"
                variant="outline-primary"
                data-testid="qa-exit-cancel-button"
                block
                onClick={handleShowAccountConvertedSuccessModalClose}>
                {i18nTranslate(
                  'ba_to_member_close_and_sign_out',
                  'Close and sign out'
                )}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

export default AccountConvertedSuccessPopup
export { AccountConvertedSuccessPopup }
